/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductSizeService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/ProductSize",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, ProductSize) {
    var payload = ProductSize;
    var url = "api/ProductSize";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.patch(url, ProductSize.Code, payload, "String");
    }
  },
};

export { ProductSizeService };
